import * as React from "react";
import { useDispatch } from "@teamprevent/admin-redux";

import { TaskModel } from "@teamprevent/common/task/taskActions/models";
import { IsLoadingButton } from "@teamprevent/common/IsLoadingButton";

import { COMPLETE_CREATE_VIDEO_CONSULTATION } from "../../../videoMeeting/actionTypes";
import { completeCreateVideoConsultation } from "../../../videoMeeting/actions";
import { ActiveTaskAction } from "../ActiveTaskAction";

interface OwnProps {
    task: TaskModel;
    customerId: string;
}

export const CompleteCreateVideoConsultationButton: React.FunctionComponent<OwnProps> = (props: OwnProps) => {
    const dispatch = useDispatch();
    const onComplete = async () => {
        await dispatch(completeCreateVideoConsultation(props.task.caseId, props.task.id));
    };

    return (
        <ActiveTaskAction task={props.task}>
            <IsLoadingButton requestNames={COMPLETE_CREATE_VIDEO_CONSULTATION} content="Complete" onClick={onComplete} floated="right" />
        </ActiveTaskAction>
    );
};
